import { useLocation } from 'react-router-dom'

import { saveState } from '../../utils/redirectState'

export function useLocationStateSaver() {
	const location = useLocation()

	return () => saveState(location)
}
